<div class="int-badge" [ngClass]="'int-' + severity" [style.border-color]="color">
  <i *ngIf="icon" [class]="icon" [style.color]="color"></i>
  <span class="int-badge__label" [style.color]="color">{{ label }}</span>
</div>
